/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost } from '../fn/project-maintenance-reports/api-project-maintenance-report-certify-project-maintenance-report-post';
import { ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-certify-project-maintenance-report-post';
import { apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain } from '../fn/project-maintenance-reports/api-project-maintenance-report-certify-project-maintenance-report-post-plain';
import { ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-certify-project-maintenance-report-post-plain';
import { apiProjectMaintenanceReportCreateProjectMaintenanceReportPost } from '../fn/project-maintenance-reports/api-project-maintenance-report-create-project-maintenance-report-post';
import { ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-create-project-maintenance-report-post';
import { apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain } from '../fn/project-maintenance-reports/api-project-maintenance-report-create-project-maintenance-report-post-plain';
import { ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-create-project-maintenance-report-post-plain';
import { apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete } from '../fn/project-maintenance-reports/api-project-maintenance-report-delete-project-maintenance-report-delete';
import { ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-delete-project-maintenance-report-delete';
import { apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain } from '../fn/project-maintenance-reports/api-project-maintenance-report-delete-project-maintenance-report-delete-plain';
import { ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-delete-project-maintenance-report-delete-plain';
import { apiProjectMaintenanceReportGetProjectMaintenanceReportGet } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-project-maintenance-report-get';
import { ApiProjectMaintenanceReportGetProjectMaintenanceReportGet$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-project-maintenance-report-get';
import { apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-project-maintenance-report-get-plain';
import { ApiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-project-maintenance-report-get-plain';
import { apiProjectMaintenanceReportGetProjectMaintenanceReportsGet } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-project-maintenance-reports-get';
import { ApiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-project-maintenance-reports-get';
import { apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-project-maintenance-reports-get-plain';
import { ApiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-project-maintenance-reports-get-plain';
import { apiProjectMaintenanceReportGetTasksInLocationGet } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-tasks-in-location-get';
import { ApiProjectMaintenanceReportGetTasksInLocationGet$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-tasks-in-location-get';
import { apiProjectMaintenanceReportGetTasksInLocationGet$Plain } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-tasks-in-location-get-plain';
import { ApiProjectMaintenanceReportGetTasksInLocationGet$Plain$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-get-tasks-in-location-get-plain';
import { apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch } from '../fn/project-maintenance-reports/api-project-maintenance-report-update-project-maintenance-report-patch';
import { ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-update-project-maintenance-report-patch';
import { apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain } from '../fn/project-maintenance-reports/api-project-maintenance-report-update-project-maintenance-report-patch-plain';
import { ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain$Params } from '../fn/project-maintenance-reports/api-project-maintenance-report-update-project-maintenance-report-patch-plain';
import { CertifyReportCommandResult } from '../models/certify-report-command-result';
import { CreateMaintenanceReportCommandResult } from '../models/create-maintenance-report-command-result';
import { DeleteMaintenanceReportCommandResult } from '../models/delete-maintenance-report-command-result';
import { GetMaintenanceReportQueryResult } from '../models/get-maintenance-report-query-result';
import { GetMaintenanceReportsQueryResult } from '../models/get-maintenance-reports-query-result';
import { GetTasksInLocationQueryResult } from '../models/get-tasks-in-location-query-result';
import { UpdateMaintenanceReportCommandResult } from '../models/update-maintenance-report-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectMaintenanceReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectMaintenanceReportGetProjectMaintenanceReportGet()` */
  static readonly ApiProjectMaintenanceReportGetProjectMaintenanceReportGetPath = '/api/ProjectMaintenanceReport/GetProjectMaintenanceReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain$Response(params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMaintenanceReportQueryResult>> {
    return apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain(params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain$Params, context?: HttpContext): Observable<GetMaintenanceReportQueryResult> {
    return this.apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMaintenanceReportQueryResult>): GetMaintenanceReportQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportGetProjectMaintenanceReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Response(params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMaintenanceReportQueryResult>> {
    return apiProjectMaintenanceReportGetProjectMaintenanceReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetProjectMaintenanceReportGet(params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportGet$Params, context?: HttpContext): Observable<GetMaintenanceReportQueryResult> {
    return this.apiProjectMaintenanceReportGetProjectMaintenanceReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMaintenanceReportQueryResult>): GetMaintenanceReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectMaintenanceReportGetProjectMaintenanceReportsGet()` */
  static readonly ApiProjectMaintenanceReportGetProjectMaintenanceReportsGetPath = '/api/ProjectMaintenanceReport/GetProjectMaintenanceReports';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain$Response(params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMaintenanceReportsQueryResult>> {
    return apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain(params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain$Params, context?: HttpContext): Observable<GetMaintenanceReportsQueryResult> {
    return this.apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMaintenanceReportsQueryResult>): GetMaintenanceReportsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportGetProjectMaintenanceReportsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Response(params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMaintenanceReportsQueryResult>> {
    return apiProjectMaintenanceReportGetProjectMaintenanceReportsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetProjectMaintenanceReportsGet(params?: ApiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Params, context?: HttpContext): Observable<GetMaintenanceReportsQueryResult> {
    return this.apiProjectMaintenanceReportGetProjectMaintenanceReportsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMaintenanceReportsQueryResult>): GetMaintenanceReportsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectMaintenanceReportGetTasksInLocationGet()` */
  static readonly ApiProjectMaintenanceReportGetTasksInLocationGetPath = '/api/ProjectMaintenanceReport/GetTasksInLocation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportGetTasksInLocationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetTasksInLocationGet$Plain$Response(params?: ApiProjectMaintenanceReportGetTasksInLocationGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTasksInLocationQueryResult>> {
    return apiProjectMaintenanceReportGetTasksInLocationGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportGetTasksInLocationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetTasksInLocationGet$Plain(params?: ApiProjectMaintenanceReportGetTasksInLocationGet$Plain$Params, context?: HttpContext): Observable<GetTasksInLocationQueryResult> {
    return this.apiProjectMaintenanceReportGetTasksInLocationGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetTasksInLocationQueryResult>): GetTasksInLocationQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportGetTasksInLocationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetTasksInLocationGet$Response(params?: ApiProjectMaintenanceReportGetTasksInLocationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTasksInLocationQueryResult>> {
    return apiProjectMaintenanceReportGetTasksInLocationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportGetTasksInLocationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportGetTasksInLocationGet(params?: ApiProjectMaintenanceReportGetTasksInLocationGet$Params, context?: HttpContext): Observable<GetTasksInLocationQueryResult> {
    return this.apiProjectMaintenanceReportGetTasksInLocationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetTasksInLocationQueryResult>): GetTasksInLocationQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost()` */
  static readonly ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPostPath = '/api/ProjectMaintenanceReport/CertifyProjectMaintenanceReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain$Response(params?: ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CertifyReportCommandResult>> {
    return apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain(params?: ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain$Params, context?: HttpContext): Observable<CertifyReportCommandResult> {
    return this.apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CertifyReportCommandResult>): CertifyReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Response(params?: ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CertifyReportCommandResult>> {
    return apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost(params?: ApiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Params, context?: HttpContext): Observable<CertifyReportCommandResult> {
    return this.apiProjectMaintenanceReportCertifyProjectMaintenanceReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CertifyReportCommandResult>): CertifyReportCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectMaintenanceReportCreateProjectMaintenanceReportPost()` */
  static readonly ApiProjectMaintenanceReportCreateProjectMaintenanceReportPostPath = '/api/ProjectMaintenanceReport/CreateProjectMaintenanceReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain$Response(params?: ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMaintenanceReportCommandResult>> {
    return apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain(params?: ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain$Params, context?: HttpContext): Observable<CreateMaintenanceReportCommandResult> {
    return this.apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateMaintenanceReportCommandResult>): CreateMaintenanceReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportCreateProjectMaintenanceReportPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Response(params?: ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMaintenanceReportCommandResult>> {
    return apiProjectMaintenanceReportCreateProjectMaintenanceReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportCreateProjectMaintenanceReportPost(params?: ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Params, context?: HttpContext): Observable<CreateMaintenanceReportCommandResult> {
    return this.apiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateMaintenanceReportCommandResult>): CreateMaintenanceReportCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch()` */
  static readonly ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatchPath = '/api/ProjectMaintenanceReport/UpdateProjectMaintenanceReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain$Response(params?: ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMaintenanceReportCommandResult>> {
    return apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain(params?: ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain$Params, context?: HttpContext): Observable<UpdateMaintenanceReportCommandResult> {
    return this.apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateMaintenanceReportCommandResult>): UpdateMaintenanceReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Response(params?: ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMaintenanceReportCommandResult>> {
    return apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch(params?: ApiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Params, context?: HttpContext): Observable<UpdateMaintenanceReportCommandResult> {
    return this.apiProjectMaintenanceReportUpdateProjectMaintenanceReportPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateMaintenanceReportCommandResult>): UpdateMaintenanceReportCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete()` */
  static readonly ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDeletePath = '/api/ProjectMaintenanceReport/DeleteProjectMaintenanceReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain$Response(params?: ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMaintenanceReportCommandResult>> {
    return apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain(params?: ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain$Params, context?: HttpContext): Observable<DeleteMaintenanceReportCommandResult> {
    return this.apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteMaintenanceReportCommandResult>): DeleteMaintenanceReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Response(params?: ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMaintenanceReportCommandResult>> {
    return apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete(params?: ApiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Params, context?: HttpContext): Observable<DeleteMaintenanceReportCommandResult> {
    return this.apiProjectMaintenanceReportDeleteProjectMaintenanceReportDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteMaintenanceReportCommandResult>): DeleteMaintenanceReportCommandResult => r.body)
    );
  }

}
